import { useCallback } from 'react';

import { getBlueprintFromBlueprintVersion } from '../../../blueprint';
import { seedStaticData } from '../../utils/staticData/seedStaticData';

import { useFetchStaticData } from './useFetchStaticData';
import { useGetBlueprintVersion } from './useGetBlueprintVersion';

import type { Blueprint } from '../../../blueprint/types';
import type { UseFeatureHook } from '../../../types';

export function useBlueprint(
  useFeature: UseFeatureHook
): () => Promise<Blueprint> {
  const fetchStaticData = useFetchStaticData();
  const getBlueprintVersion = useGetBlueprintVersion(useFeature);

  return useCallback(async (): Promise<Blueprint> => {
    const [staticData, blueprintVersion] = await Promise.all([
      fetchStaticData(),
      getBlueprintVersion(),
    ]);

    const unseededBlueprint =
      getBlueprintFromBlueprintVersion(blueprintVersion);

    const seededBlueprint = seedStaticData(
      unseededBlueprint,
      staticData.data.staticData
    );

    return seededBlueprint;
  }, [fetchStaticData, getBlueprintVersion]);
}
